import { createApp } from "vue";
import App from "./App.vue";
import store from "./store";
import router from "./router";
import "./assets/css/nucleo-icons.css";
import "./assets/css/nucleo-svg.css";
import ArgonDashboard from "./argon-dashboard";
import { vfmPlugin } from 'vue-final-modal';
import "./assets/css/row-highlight.css";
import rowHighlight from "./helpers/rowHighlight";

const appInstance = createApp(App);
appInstance.use(store);
appInstance.use(router);
appInstance.use(ArgonDashboard);
appInstance.use(vfmPlugin);
appInstance.use(rowHighlight, { router });
appInstance.mount("#app");